<div class="delegation-cost-form">
  <div class="content-card">
    <h2 class="content-card__header">{{ 'DMF-DelegationMileage' | translate }}</h2>

    <form [formGroup]="formGroup">

      <div class="row">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DMF-DepartureCity' | translate }}</mat-label>
            <input
              matInput
              formControlName="departureCity"
              placeholder="{{ 'DMF-DepartureCity' | translate }}"
              [matAutocomplete]="autocompleteDepartureCity"
              />
              <mat-autocomplete #autocompleteDepartureCity="matAutocomplete">
                @for (city of listOfDepartureCities$ | async; track city) {
                  <mat-option [value]="city">
                    {{ city }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="col-12 col-lg-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'DMF-StartDate' | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="pickStartDate"
                formControlName="startDate"
                />
                <mat-datepicker-toggle matSuffix [for]="pickStartDate"></mat-datepicker-toggle>
                <mat-datepicker #pickStartDate></mat-datepicker>
                @if (startDate.invalid && startDate.touched) {
                  <mat-error>
                    {{ 'InvalidField' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'DMF-DestinationCity' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="destinationCity"
                  placeholder="{{ 'DF-DestinationCity' | translate }}"
                  [matAutocomplete]="autocompleteDestinationCity"
                  />
                  <mat-autocomplete #autocompleteDestinationCity="matAutocomplete">
                    @for (city of listOfDestinationCities$ | async; track city) {
                      <mat-option [value]="city">
                        {{ city }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>

              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'DMF-EndDate' | translate }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickEndDate"
                    formControlName="endDate"
                    />
                    <mat-datepicker-toggle matSuffix [for]="pickEndDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickEndDate></mat-datepicker>
                    @if (endDate.invalid && endDate.touched) {
                      <mat-error>
                        {{ 'InvalidField' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-lg-6">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'DMF-MileageTransportType' | translate }}</mat-label>
                    <mat-select formControlName="delegationMileageTransportTypeId">
                      @for (transportType of listOfDelegationMileageTransportTypes$ | async; track transportType) {
                        <mat-option [value]="transportType.Id"> {{ transportType.Name }} </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12 col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'DMF-KilometersNumber' | translate }}</mat-label>
                    <input appNumbersOnly matInput formControlName="kilometersNumber" />
                  </mat-form-field>
                </div>
                <div class="col-12 col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'DMF-KilometerRate' | translate }}</mat-label>
                    <input matInput formControlName="kilometerRate" />
                  </mat-form-field>
                </div>
                <div class="col-12 col-lg-2">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'DMF-GrossValue' | translate }}</mat-label>
                    <input matInput formControlName="grossValue" />
                  </mat-form-field>
                </div>
              </div>

              <div class="header-wrapper"></div>

              <div fxLayout='row' fxLayoutAlign='end space-between center'>
                <button mat-raised-button color="accent" (click)="close()">{{ 'Close' | translate }}</button>
                @if (isEditMode) {
                  <button mat-raised-button color="primary" (click)="saveMileage()">{{ 'Save' | translate }}</button>
                }
              </div>
            </form>
          </div>
        </div>